module.exports = __webpack_public_path__ + "img/surat-agenda2.539de5db.svg";